import { formatTime } from "../../framework/utils/format-time/format-time.js";
import { IconSchedule } from "../icon/variants/IconSchedule.js";
import { Flex } from "../mantine-passthroughs/index.js";
import { BaseCard } from "../card/BaseCard.js";
import { Body1 } from "../typography/Body1.js";
import { Subtitle2 } from "../typography/Subtitle2.js";
import { Modal } from "../modal/Modal.js";
import { HoursByDay } from "./HoursByDay.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useDisclosure } from "@mantine/hooks";

//#region src/components/hours-of-operation/HoursOfOperation.tsx
const HoursOfOperation = ({ day, times, showIcon = true, actionable = true, weeklyHours, inline = false, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	const [opened, { open, close }] = useDisclosure(false);
	const isValidTime = !!times[0] && !!times[1];
	const DayComponent = inline ? Body1 : Subtitle2;
	return /* @__PURE__ */ jsxs(BaseCard, {
		Icon: showIcon ? IconSchedule : void 0,
		iconColor: actionable ? "primary" : "secondary",
		p: 0,
		style: { boxShadow: "none" },
		"data-testid": testId,
		children: [/* @__PURE__ */ jsxs(Flex, {
			style: { cursor: actionable ? "pointer" : void 0 },
			gap: "xxxs",
			onClick: open,
			direction: inline ? "row" : "column",
			children: [day ? /* @__PURE__ */ jsx(DayComponent, {
				inline,
				children: day
			}) : void 0, isValidTime ? /* @__PURE__ */ jsx(Body1, {
				inline,
				children: t("hoursOfOperation.times", {
					startTime: formatTime(times[0]),
					endTime: formatTime(times[1])
				})
			}) : /* @__PURE__ */ jsx(Body1, {
				inline,
				children: t("hoursOfOperation.closed")
			})]
		}), weeklyHours ? /* @__PURE__ */ jsx(Modal, {
			title: t("hoursOfOperation.weeklyHoursModal"),
			onClose: close,
			opened,
			children: /* @__PURE__ */ jsx(HoursByDay, { hours: weeklyHours })
		}) : null]
	});
};

//#endregion
export { HoursOfOperation };